export default function Projects() {
  const projects = [
    {
      name: "BEC College Website",
      description:
        "A full-stack web application for a college website built with React.js, Node.js, Express, and MongoDB. Designed responsive layouts and implemented SCSS styling.",
      tech: ["React.js", "Node.js", "Express", "MongoDB", "SCSS"],
      github: "https://github.com/arisrada/BEC-Website",
      live: "#", // Add a live link if hosted
    },
    {
      name: "IETE Chennai Chapter Website",
      description:
        "A modern, responsive redesign of the IETE Chennai Chapter website. Features smooth animations, interactive navigation, and a mobile-friendly layout.",
      tech: ["HTML", "CSS", "JavaScript", "SCSS"],
      github: "#",
      live: "https://main--elite-design.netlify.app/",
    },
  ];

  return (
    <div className="min-h-screen bg-[#000000] py-12 px-6 md:px-20">
      <h2 className="text-3xl font-bold text-white text-center mb-10">
        Projects
      </h2>
      <div className="grid gap-8 md:grid-cols-2">
        {projects.map((project, index) => (
          <div
            key={index}
            className="bg-[#000000] p-6 shadow-xl rounded-lg hover:shadow-xl transition"
            style={{ boxShadow: "0 4px 12px rgba(255, 255, 255, 0.1)" }}
          >
            <h3 className="text-xl font-semibold text-white">{project.name}</h3>
            <p className="text-white my-3">{project.description}</p>
            <div className="mb-4">
              <span className="font-medium text-white">Tech Stack:</span>
              {project.tech.join(", ")}
            </div>
            <div className="flex gap-4">
              {project.github !== "#" && (
                <a
                  href={project.github}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white underline"
                >
                  GitHub
                </a>
              )}
              {project.live !== "#" && (
                <a
                  href={project.live}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white underline"
                >
                  Live Demo
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
